import { css } from '@emotion/react';

export type Mixins = typeof mixins;

export const mixins = {
    border: (colour = 'red') => css`
    border: ${colour} solid 1px;
    `
};
